module.exports = __webpack_public_path__ + "static/media/customPostAssessment2.2a28066f.png";